import { PERKS_MULTIPLIER } from '../constants';

export const getPerksValue = (value: number, shippingProtectionBonus: boolean = false): number => {
    let perks: number;

    if (value <= 50) {
        perks = 5;
    } else if (value <= 100) {
        perks = 10;
    } else if (value <= 150) {
        perks = 15;
    } else if (value <= 250) {
        perks = 20;
    } else {
        perks = 25;
    }

    const finalPerks = shippingProtectionBonus ? perks * PERKS_MULTIPLIER : perks;
    return Number(finalPerks.toFixed(2));
};

export const getNextPerksValue = (value: number): number => {
    const perks = getPerksValue(value);

    return perks < 25 ? perks + 5 : perks;
};

export const getMissingValueForNextPerksValue = (value: number): number | null => {
    if (value < 50) {
        return 50 - value;
    }

    if (value < 100) {
        return 100 - value;
    }

    if (value < 150) {
        return 150 - value;
    }

    if (value < 250) {
        return 250 - value;
    }

    return null;
};
